import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {/* Brand */}
          <div>
            <span className="text-xl md:text-2xl font-heading font-bold text-white tracking-tight">
              Vigorbuy
            </span>
            <p className="mt-3 text-sm text-secondary-300 leading-relaxed max-w-xs">
              A structured spreadsheet intelligence system for smarter product comparison and discovery. Make informed decisions faster.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-label font-semibold text-white mb-4 uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Vigorbuy Sheet
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Buy It Now
                </a>
              </li>
              <li>
                <Link
                  to="/vigorbuy-spreadsheet-guide"
                  className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Complete Guide
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-sm font-label font-semibold text-white mb-4 uppercase tracking-wider">
              Explore
            </h4>
            <p className="text-sm text-secondary-300 leading-relaxed">
              Discover how the vigorbuy spreadsheet system simplifies your product research and shopping experience.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 rounded-full bg-accent-500 text-background-50 text-sm font-label font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Visit Vigorbuy Sheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 md:mt-14 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} Vigorbuy. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer whitespace-nowrap">
              Home
            </Link>
            <Link to="/vigorbuy-spreadsheet-guide" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors cursor-pointer whitespace-nowrap">
              Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}